
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.286.273a.92.92 0 00-.01 1.292l5.24 5.428 5.241-5.428a.92.92 0 00-.01-1.292.923.923 0 00-1.31.006L5.516 4.296 1.596.279A.923.923 0 00.286.273z"}})])
          )
        }
      }
    